import { useState, useEffect } from "react";
import MDFormL from "../../../MarketingBoard/Registration/components/MDFormL";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { alreadyRegApplication, getOneContractFarmingDetails } from "../../../../auth/services/privateapicalling";
import SponsorRegistrationP1 from "./Page1";
import { Link } from "react-router-dom";
import DocView from "../../../MarketingBoard/Registration/components/DocView";
import MBAFormJ from "../../../MarketingBoard/Registration/components/MBAFormJ";

const RegistrationStatus = () => {

    const navigate = useNavigate();

    const token = useSelector((state: any) => state.auth.token);
    const userDetail = useSelector((state: any) => state.auth.userDetails);
    const roleIdentifier = userDetail?.Role?.Role_Identifier;
   
    const location =useLocation()
    const applicationId=location?.state?.applicationId
    // 1001760188065769

    const [status, setStatus] = useState("pending");
    const [sponsorId, setSponsorId] = useState("");
    const [appliedDate, setAppliedDate] = useState("");
    const [loading, setLoading] = useState(true);
    const [mdComment, setMdComment] = useState(""); // Add this line
    const [rejectDocId, setRejectDocId] = useState("")
    const [applicationDataInfo, setApplicationDataInfo] = useState(null)

   

    useEffect(() => {
        const fetchApplicationData = async () => {
            try {
                setLoading(true);
                const response = await getOneContractFarmingDetails(applicationId, token);
                
                if (response.success && response.data) {
                    // Set Sponsor Registration Number
                    setSponsorId(response.data?.Sponsor_Registration_No || "N/A");
                    
                    // Set Applied Date (createdAt)
                    setAppliedDate(response.data?.createdAt || "N/A");
                    
                    setApplicationDataInfo(response.data)

                    // Set Status
                    setStatus(response.data?.status || "pending");

                    // setMdComment(response.data?.pendingAtMBMD?.comment || "N/A");
                                        
                    setMdComment((response.data?.transaction?.pendingAtMBMDResubmission ? response?.data?.transaction?.pendingAtMBMDResubmission?.comment : response?.data?.transaction?.pendingAtMBMD?.comment) || "N/A")

                    setRejectDocId(response.data?.transaction?.pendingAtMBMDResubmission?.reSubmittedFields?.rejectionFile?.data[0]?.docId || response.data?.transaction?.pendingAtMBMD?.reSubmittedFields?.rejectionFile?.data[0]?.docId)
                   

                }
            } catch (error) {
               
            } finally {
                setLoading(false);
            }
        };

        if (applicationId && token) {
            fetchApplicationData();
        }
    }, [applicationId, token]);


    const handleRedirect = () => {
        navigate("/sponsor-agreement");
    };
    const handleRedirectReg = () => {
        navigate("/sponsor-registration");
    };

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <div className="d-flex flex-column gap-5 m-5 text-nightblue justify-content-center">
                <div className="d-flex flex-column justify-content-between align-items-center">
                    <div className="d-flex w-100">
                        <div className="py-2 w-100 d-flex flex-column gap-2">
                            <h2>
                                My Application Status
                            </h2>
                            <p className={` fs-20 ${(status==="reject" || status==="permanentReject") ? "text-danger" : "text-success"}`}>
                                    {/* Your application is {status === "pending" ? "Submitted and currently Under Review" : "Approved"} */}
                                {status === "pending"
                                ? "Application is Successfully Submitted and currently under Review"
                                : status === "draft"
                                ? "Complete your Application and do the Payment"
                                : status === "approved"
                                ? "Your application has been approved and your registration is now complete. You can now proceed to start applying for agreements"
                                : status === "reject"
                                ? "Your application have some queries. See the comment and Try Again. Click on 'Go to My Application' Button to edit"
                                : status === "resubmission"
                                ? "Application is Successfully Re-submitted and currently under Review"
                                : status === "permanentReject"
                                ? "Your application is Rejected. Make a new Registration."
                                : ""}
                            </p>
                            <p className="fs-20">
                                Application Progress
                            </p>
                        </div>
                        {status === "approved" && (
                            <div className="w-25 d-flex justify-content-end align-items-center">
                                <button onClick={handleRedirect} className="btn btn-info">
                                    <i className="feather feather-plus-circle me-2"></i>
                                    Make New Agreement
                                </button>
                            </div>
                        )}
                        {(status === "reject" || status === "permanentReject" || status==="draft") && (
                            <div className="w-25 d-flex justify-content-end align-items-center">
                                <button onClick={handleRedirectReg} className="btn btn-info">
                                    <i className="feather feather-plus-circle me-2"></i>
                                    {status==="permanentReject" ? "New Registration" : "Go to My Application"}
                                </button>
                            </div>
                        )}
                       
                    </div>
                    <div className="m-3 d-flex justify-content-center align-items-center">
                        {/* Step 1 */}
                        <div className="d-flex flex-column align-items-center gap-1" style={{ minWidth: "80px" }}>
                            <div
                                className={`rounded-circle d-flex bg-white justify-content-center align-items-center border border-2
                                    ${status === "draft" ? "border-info" : "border-success"}`}
                                style={{
                                    height: "50px",
                                    width: "50px",
                                    fontSize: "1.5rem"
                                }}
                            >
                                {/* <i className={`feather feather-check-circle fs-3  ${status === "draft" ? "text-info" : "text-success"}`}></i> */}
                                {status === "draft"
                                    ? <i className="feather feather-clock text-info fs-3"></i>
                                    : <i className="feather feather-check-circle text-success fs-3"></i>}
                            </div>
                             <p className={status === "draft" ? "text-info" : "text-success"}>Submitted</p>
                        </div>

                        <div className="bg-dark" style={{ height: "2px", width: "200px", position: "relative", top: "-10px" }}></div>

                        {/* Step 2 */}
                        <div className='d-flex flex-column align-items-center gap-1' style={{ minWidth: "80px" }}>
                            <div
                                className={`rounded-circle d-flex bg-white justify-content-center align-items-center border border-2
                                    ${status === "pending" || status==="draft" ? "border-info" : "border-success"}`}
                                style={{
                                    height: "50px",
                                    width: "50px",
                                    fontSize: "1.5rem"
                                }}
                            >
                                {status === "pending" || status==="draft"
                                    ? <i className="feather feather-clock text-info fs-3"></i>
                                    : <i className="feather feather-check-circle text-success fs-3"></i>}
                            </div>
                            <p className={status === "pending" || status==="draft" ? "text-info" : "text-success"}>Review</p>
                        </div>
                        <div className="bg-dark" style={{ height: "2px", width: "200px", position: "relative", top: "-10px" }}></div>

                        {/* Step 3 */}
                        <div className={`d-flex flex-column align-items-center gap-1 ${status === "approved" ? "text-success" : status === "reject" ? "text-danger" : "text-gray"}`} style={{ minWidth: "80px" }}>
                            <div
                                className={`rounded-circle border border-2 bg-white d-flex justify-content-center align-items-center ${status === "approved" ? "border-success" : status === "reject" ? "border-danger" : "border-secondary"}`}
                                style={{
                                    height: "50px",
                                    width: "50px",
                                    fontSize: "1.5rem"
                                }}
                            >
                                <i className={`feather feather-user-check fs-3`}></i>
                            </div>
                            {status === "approved" ? <p className="text-success">Approved</p> : status === "reject" ? <p className="text-danger">Query Raised</p>:status === "permanentReject" ? <p className="text-danger">Rejected</p> : <p className="text-gray">Approved</p>}
                        </div>
                    </div>
                    <div className="p-4 mt-5 rounded-3 shadow-sm w-100 text-black" style={{ fontSize: "1rem", backgroundColor: "#D9D9D9" }}>
                        <div className="d-flex align-content-items justify-content-between w-100">
                            <p className="my-2">Sponsor ID:</p>
                            <p className="my-2">{sponsorId}</p>
                        </div>

                        <div style={{ height: "2px", backgroundColor: "#B7B7B7" }}></div>

                        <div className="d-flex justify-content-between w-100">
                            <p className="my-2">Application ID:</p>
                            <p className="my-2">{applicationId}</p>
                        </div>

                        <div style={{ height: "2px", backgroundColor: "#B7B7B7" }}></div>

                        <div className="d-flex justify-content-between w-100">
                            <p className="my-2">Applied Date</p>
                            <p className="my-2">{appliedDate}</p>
                        </div>

                        <div style={{ height: "2px", backgroundColor: "#B7B7B7" }}></div>

                        <div className="d-flex justify-content-between w-100">
                            <p className="my-2">Status</p>
                            <p className={`my-2 ${status === "approved" ? "text-success" : "text-danger"}`}>{status==="reject" ? "Query Raised" : status==="permanentReject" ? "Rejected" : status?.toUpperCase()}</p>
                        </div>
                    </div>
                    {status === "pending" && (
                        <div className="mt-3" style={{fontSize:"1.25rem"}}>
                            <p>You will be notified once the status is updated.</p>
                        </div>
                    )}
                </div>
            </div>
            {roleIdentifier === "SPO" && (status==="approved" || status==="reject" || status==="permanentReject") && (
                        <div className="mx-5 mt-4">
                            <p className="fw-bold text-black" style={{fontSize:"1.4rem"}}>
                                Comment from Marketing Board Managing Director: 
                                <span className="fw-normal bg-white p-2 rounded border border-secondary d-block mt-2" style={{fontSize:"1.2rem"}}>
                                    {mdComment}
                                </span>
                            </p>
                        </div>
                    )}

            {status === "approved" ? (
                <div className="d-flex bg-white rounded-3 shadow-sm flex-column m-5 text-nightblue justify-content-center">
                    {/* <div className="d-flex justify-content-between align-items-center">
                        <div className="py-2 d-flex flex-column gap-2">
                            <h3 className="d-flex align-items-center">
                                <i className="feather feather-check-circle text-success p-1 me-2 fs-3"></i>
                                Registration Completed Successfully
                            </h3>
                            <p className="ms-1">
                                Your application has been approved and your registration is now complete. You can now
                                proceed to start applying for agreements
                            </p>
                        </div>
                    </div> */}
                    <div>
                        <MDFormL applicationId={applicationId} />
                    </div>
                </div>
            ):(
            //     <SponsorRegistrationP1
            //   onNext={null}
            //   // applicationData={applicationData}
            //   applicationId={applicationId}
            //   canOnlyView={true}
            //   couchId={null}
            // />
            <MBAFormJ applicationId={applicationId} applicationDataInfo={applicationDataInfo} valCalledIn={"registrationStatus"}  />
            )}

            {status === "permanentReject" && rejectDocId && (
                <div className="m-5">
                    <h3 className="mb-3">
                        Document Uploaded by Marketing Board Managing Director
                    </h3>
                    <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#contract_farming_modal"
                  className="btn btn-info align-items-center w-25"
                  data-doc-id={rejectDocId}
                >
                  <i className="ti ti-eye"></i> View Document
                </Link>
                </div>
            )}
                  <DocView/>

        </div>
    );
};

export default RegistrationStatus;